/* eslint-disable max-lines */
import {
  subMerchantActivity,
  subMerchantCountDataCompleted,
  subMerchantCountDataXOnBoard,
  subMerchantCountOnboarding,
  subMerchantCountTransaction,
  subMerchantCountTrxXOnBoard,
  subMerchantRegionalActivity
} from '../../utils/api';
import { filterBuilder } from '../../utils/builder/settingDataSubMerchant';
import { actionTypes } from './constants';

export function setFailedAction({ key, message, error, data }) {
  return { type: actionTypes.FAILED, key, message, error, data };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
  success = true
}) {
  return { type: actionTypes.SUCCESS, key, data, meta, initial, message, success };
}

export function setFilterAction({ key, filter = {} }) {
  return { type: actionTypes.FILTER, key, filter };
}

export function setMessageAction({ key, message }) {
  return { type: actionTypes.MESSAGE, key, message };
}

export function fetchSubMerchantActivity({ filter }) {
  const key = 'activity';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantActivity(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSubMerchantRegionalActivity({ filter }) {
  const key = 'regionalActivity';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantRegionalActivity(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSubMerchantCountDataCompleted({ filter }) {
  const key = 'countDataCompleted';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantCountDataCompleted(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSubMerchantCountOnboarding({ filter }) {
  const key = 'countOnboarding';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantCountOnboarding(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSubMerchantCountTransaction({ filter }) {
  const key = 'countTransaction';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantCountTransaction(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSubMerchantCountDataXOnBoard({ filter }) {
  const key = 'countDataXOnBoard';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantCountDataXOnBoard(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSubMerchantCountTrxXOnBoard({ filter }) {
  const key = 'countTrxXOnBoard';
  return async (dispatch) => {
    try {
      dispatch(setLoadingAction({ key }));
      const response = await subMerchantCountTrxXOnBoard(filterBuilder(filter));
      dispatch(setSuccessAction({ key, data: response.data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function setSubMerchantFilter(filter) {
  return async (dispatch) => {
    dispatch(
      setFilterAction({
        key: 'local',
        filter,
      })
    );
  };
}


export const clearRedux = () => {
  return async (dispatch) => {
    dispatch(setSuccessAction({ key: 'bank', data: {}, message: '' }));
    dispatch(setSuccessAction({ key: 'agen', data: {}, message: '' }));
    dispatch(setFailedAction({ key: 'agen', message: '' }));
    dispatch(setFailedAction({ key: 'identity', message: '' }));
    dispatch(setFailedAction({ key: 'sync', message: '' }));
  };
};
